import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../model/message.model';
import { BehaviorDataService } from '../../../service/behaviorData.service';
import { DepositService } from '../../../service/deposit.service';
import { MessageComponent } from '../../../shared/components/messages/message-component';

@Component({
    selector: 'app-flash1-voucher-input',
    templateUrl: 'flash1voucher-input.component.html',
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MessageComponent, TranslateModule],
})
export class Flash1VoucherInputComponent implements OnInit, OnDestroy {
    depositService = inject(DepositService);
    private behaviorData = inject(BehaviorDataService);

    @Input() voucherInputFormGroup: FormGroup;
    subscriptions$: Subscription[] = [];
    flashVoucherErrorDetails: any;
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit(): void {
        this.voucherInputFormGroup.addControl(
            'voucherInput',
            new FormControl('', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]),
        );

        this.subscriptions$.push(
            this.behaviorData.getFlashVoucherErrorDetails.subscribe((data) => {
                this.flashVoucherErrorDetails = data;
            }),
        );
    }

    validateVoucherInput() {
        this.behaviorData.changeFlashVoucherErrorDetails(null);
    }

    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
